<template>
  <div class="SlideShow" @mousemove="$emit('done')">
    <template v-for="(image, index) in Object.values(c_slides)">
      <div
        class="SlideWrapper"
        :class="{ visible: activeIndex == index, hidden: activeIndex != index }"
      >
        <img
          v-if="image.type == 'image'"
          :ref="activeIndex == index ? 'current' : 'hidden'"
          :src="image.url"
          class="fullHeight contain"
        />
        <video
          v-else-if="image.type == 'video'"
          :ref="activeIndex == index ? 'current' : 'hidden'"
          class="fullHeight contain"
          :src="image.url"
          muted="muted"
          @ended="next"
        />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeIndex: -1,
    };
  },
  computed: {
    c_slides() {
      return this.$store.getters["getSlides"];
    },
    c_slideDuration() {
      return this.$store.getters["getSlideDuration"];
    },
  },
  methods: {
    start() {
      setTimeout(() => {
        if (this.$refs.current[0].localName == "video") {
          this.$refs.current[0].play();
        }
      }, 400);
    },
    next() {
      let newIndex;
      if (this.activeIndex + 1 >= Object.values(this.c_slides).length) {
        this.activeIndex = -1;
        return this.$emit("done");
      } else {
        newIndex = this.activeIndex + 1;
      }
      if (Object.values(this.c_slides)[newIndex].type == "image") {
        setTimeout(() => {
          this.next();
        }, this.c_slideDuration * 1000);
      } else {
        this.start();
      }
      this.activeIndex = newIndex;
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler() {
        if (this.visible) {
          this.next();
        }
      },
    },
  },
};
</script>

<style scoped>
.SlideShow,
.SlideWrapper {
  position: fixed;
  top: 0;
  max-width: 100vw;
  max-height: 100vh;
  min-width: 100vw;
  min-height: 100vh;
  background: black;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.SlideShow image,
.SlideShow video {
  width: 100%;
  padding: 64px;
}
.SlideShow video {
  object-fit: scale-down;
}
.visible {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.5s linear;
  transition-delay: 0.25s;
  -webkit-transition-delay: 0.5s;
  -moz-transition-delay: 0.5s;
  -o-transition-delay: 0.5s;
}
.hidden {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s 0.3s, opacity 0.3s linear;
}
</style>
